export default __webpack_public_path__ + "static/media/cn.1569944a.svg";